import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {BodyComponent} from './source/includes/body.component';
import {DeniedComponent} from './source/denied/denied';
// User
import {ProfileComponent} from './source/user/profile.component ';
import {RolesComponent} from './source/roles/roles';
import {UsersComponent} from './source/user/users.component';
import {ImportCustomersComponent} from './source/import_customers/import_customers';
import {ImportVendorsComponent} from './source/import_vendors/import_vendors';

// Controlers
import {LoginComponent} from './login/login.component';
import {LockingComponent} from './locking/locking.component';
import {MiscsettingsComponent} from './miscsettings/miscsettings.component';
import {LogoutComponent} from './login/login.component';

import {ForgetComponent, ResetComponent} from './forget/forget.component';

// Settings
import {GeneralsettingsComponent} from './source/general_settings/general_settings.component';
import {PermissionComponent} from './source/permissions/permission';

// Inventory
import {DashboardComponent} from './source/dashboard.component';
import {ModifiresComponent, ModifireGroupsComponent} from './source/modifiers/modifiers';
import {BusinessTypeComponent} from './source/business_type/business_type';
import {ItemsComponent} from './source/items/items';
// import {AddItemComponent} from './source/items/add_item';
import {ReceiveComponent} from './source/Inventory/receive/receive_inventory';
import {MassComponent} from './source/Inventory/mass/mass_inventory';
import {ReturnComponent} from './source/Inventory/return/return_inventory';
import {CountComponent} from './source/Inventory/count/count_inventory';
// POS
import {CustomersComponent} from './source/customers/customers';
import {DepartmentsComponent} from './source/departments/departments';
import {CategoriesComponent} from './source/categories/categories';
import {TaxComponent} from './source/tax/tax';
import {VandorsComponent} from './source/vandors/vandors';
import {PromotionsComponent} from './source/promotions/promotions';
import {LoyaltyComponent} from './source/loyality/loyalty';
import {SellComponent} from './source/sell/sell';
import {PaymentComponent} from './source/payment/payment';
import {ImportItemsComponent} from './source/import_items/import_items';
import {StoresComponent, AddstoreComponent} from './source/stores/stores';
import {ClosedayComponent} from './source/closeday/closeday';

import {VariantsComponent, VariantsGroupsComponent} from './source/variants/variants';
import {TimeClockComponent} from './source/timeclock/timeclock';
import {StimulsoftReportComponent} from './source/stimulsoft-report/stimulsoft-report.component';
import {DevicesComponent} from './source/approval/pos_devices';
import {AttendanceReportComponent} from './source/attendanceReport/attendanceReport';
import {EmployeeActivityComponent} from './source/employee_activity/employee_activity';
import {PrinterGroupsComponent, PrintersComponent} from './source/printer/printers';
import {NotFountComponent} from './source/404/404';
import {PrintReportComponent} from './source/print-report/print-report.component';
// import {EditItemComponent} from './source/items/edit-item/edit-item.component';
import {EditItemsComponent} from './source/edit-items/edit-items.component';

////////// Reports ////////////////////
import {ItemSalesComponent} from './source/item_sales/item_sales';
import {SaleSummaryComponent} from './source/sale_summary/sale_summary';
import {StoreSummaryComponent} from './source/store_summary/store_summary';
import {InventorySnapshotComponent} from './source/inventory_snapshot/inventory_snapshot';
import {DayclosePrintComponent} from './source/daycloseprint/daycloseprint';
import {EmployeesComponent} from './source/employees/employees';
import {PosSettingsComponent} from './source/possettings/component/possettings/possettings.component';
import {AppsComponent} from './source/apps/apps.component';
import {AppsActivationComponent} from './source/apps-activation/apps-activation.component';
import {DriversComponent} from './source/drivers/drivers.component';
import {FodiEatInfoComponent} from './source/items/fodi-eat-info/fodi-eat-info.component';
import {OrdersListComponent} from './source/orders-list/orders-list.component';
import {EmailComponent} from './source/email/email.component';
import {ReasonComponent} from './source/reason/reason.component';
import {HomeComponent} from './source/home/home.component';
import {EditEmailComponent} from './source/edit-email/edit-email.component';
import {AddItemsComponent} from './source/add-items/add-items.component';
import {AddVariantComponent} from './source/items/add-variant/add-variant.component';
import {EditItemComponent} from './source/items/edit-item/edit-item.component';
import {ReturnInventoryModule} from './source/Inventory/return/module/return-inventory.module';
import {InventorySnapshotModule} from './source/inventory_snapshot/module/inventory-snapshot.module';
import {ItemSalesModule} from './source/item_sales/module/item-sales.module';
import {FodiEatInfoModule} from './source/items/fodi-eat-info/module/fodi-eat-info.module';
import {LoyalityProgramModule} from './source/loyality/module/loyality-program.module';
import {ModifiersModule} from './source/modifiers/modifiers_module/modifiers.module';
import {ModifiersGroupModule} from './source/modifiers/modifiers-group-module/modifiers-group.module';
import {OrdersListModule} from './source/orders-list/module/orders-list.module';
import {PaymentModule} from './source/payment/module/payment.module';
import {PermissionModule} from './source/permissions/module/permission.module';
import {PrinterGroupModule} from './source/printer/printer-group_module/printer-group.module';
import {PrintReportModule} from './source/print-report/module/print-report.module';
import {PromotionsModule} from './source/promotions/module/promotions.module';
import {RolesModule} from './source/roles/module/roles.module';
import {SaleSummaryModule} from './source/sale_summary/module/sale-summary.module';
import {StimulsoftReportModule} from './source/stimulsoft-report/module/stimulsoft-report.module';
import {StoreSummaryModule} from './source/store_summary/module/store-summary.module';
import {StoresModule} from './source/stores/stores_module/stores.module';
import {AddStoreModule} from './source/stores/add-store_module/add-store.module';
import {TaxModule} from './source/tax/module/tax.module';
import {TimeClockModule} from './source/timeclock/module/time-clock.module';
import {UsersModule} from './source/user/users_module/users.module';
import {ProfileModule} from './source/user/profile_module/profile.module';
import {VandorsModule} from './source/vandors/module/vandors.module';
import {VariantGroupModule} from './source/variants/variant-group_module/variant-group.module';
import {BusinessTypeModule} from './source/business_type/module/business-type.module';
import {DayClosePrintModule} from './source/daycloseprint/day-close-print/day-close-print.module';
import {PageNotFoundRoutingModule} from './source/404/module/page-not-found-routing.module';
import {PageNotFoundModule} from './source/404/module/page-not-found.module';
import {DeniedModule} from './source/denied/module/denied.module';
import {ReasonModule} from './source/reason/module/reason.module';
import {ThemeModule} from './source/theme/module/theme.module';
import {SettingComponent} from './source/dining/settings/apps_settings/setting';


const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'locking', component: LockingComponent},
  {path: 'miscsettings', component: MiscsettingsComponent},
  
  {path: 'logout', component: LogoutComponent},
  {path: 'forget', component: ForgetComponent},


  {
    path: 'reset/:token', component: ResetComponent,
    children: [
      {path: '**', component: ResetComponent}
    ]
  },
  /// User Routs
  
  {
    path: '404', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/404/module/page-not-found.module#PageNotFoundModule'}
    ]
  },
  {
    path: 'denied', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/denied/module/denied.module#DeniedModule'}
    ]
  },
  {
    path: 'users', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/user/users_module/users.module#UsersModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'profile', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/user/profile_module/profile.module#ProfileModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'roles', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/roles/module/roles.module#RolesModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'time-clock', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/timeclock/module/time-clock.module#TimeClockModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
{
  path: 'possettings',
  component: BodyComponent,
  children: [
    { path: '', component: PosSettingsComponent },
    { path: '**', redirectTo: '404' }
  ]
},

  // Dashboard Pages
  {
    path: 'home', component: BodyComponent,
    children: [
      // Dashboard Pages
      {path: '', loadChildren: './source/home/module/home.module#HomeModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  // Switch Store Page
  {path: 'switch-store', loadChildren: './source/switch_store/module/switch_store.module#SwitchStoreModule'},

  // Dashboard Pages
  {
    path: 'dashboard', component: BodyComponent,
    children: [
      // Dashboard Pages
      {path: '', component: DashboardComponent},
      {path: '**', redirectTo: '404'}
    ]
  },

  // apps Pages
  {
    path: 'apps', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/apps/module/apps.module#AppsModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // apps activation
  {
    path: 'apps-activation', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/apps-activation/module/apps-activation.module#AppsActivationModule'},
      {path: ':id', loadChildren: './source/apps-activation/module/apps-activation.module#AppsActivationModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // drivers
  {
    path: 'drivers', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/drivers/module/drivers.module#DriversModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // email
  {
    path: 'email', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/email/module/email.module#EmailModule'},
      {path: ':id', loadChildren: './source/edit-email/module/edit-email.module#EditEmailModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // reason
  {
    path: 'reason', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/reason/module/reason.module#ReasonModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // fodiEat info
  {
    path: 'fodiEat_info', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/items/fodi-eat-info/module/fodi-eat-info.module#FodiEatInfoModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // orders list
  {
    path: 'orders_list', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/orders-list/module/orders-list.module#OrdersListModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  // SETTINGS
  {
    path: 'settings', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/general_settings/module/general-settings.module#GeneralSettingsModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'permission', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/permissions/module/permission.module#PermissionModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  // {
  //   path: 'variants', component: BodyComponent,
  //   children: [
  //     // Category Pages
  //     {path: '', component: VariantsComponent},
  //     {path: '**', redirectTo: '404'}
  //   ]
  // },
  {
    path: 'variants-groups', component: BodyComponent,
    children: [
      // Category Pages
      {path: '', loadChildren: './source/variants/variant-group_module/variant-group.module#VariantGroupModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'modifire', component: BodyComponent,
    children: [
      // Modifires Pages
      {path: '', loadChildren: './source/modifiers/modifiers_module/modifiers.module#ModifiersModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'modifire-groups', component: BodyComponent,
    children: [
      // Modifires Pages
      {path: '', loadChildren: './source/modifiers/modifiers-group-module/modifiers-group.module#ModifiersGroupModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  {
    path: 'printer', component: BodyComponent,
    children: [
      // printer Pages
      {path: '', loadChildren: './source/printer/printer_module/printers.module#PrintersModule'},
      {path: 'groups', loadChildren: './source/printer/printer-group_module/printer-group.module#PrinterGroupModule'},
      {path: 'config', loadChildren: './source/printer/printer-config/printer-config.module#PrinterConfigModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  {
    path: 'businessType', component: BodyComponent,
    children: [
      // Business Type Pages
      {path: '', loadChildren: './source/business_type/module/business-type.module#BusinessTypeModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  // Inventory
  {
    path: 'return', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/Inventory/return/module/return-inventory.module#ReturnInventoryModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'receive', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/Inventory/receive/module/receive-inventory.module#ReceiveInventoryModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'mass', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/Inventory/mass/module/mass-inventory.module#MassInventoryModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'count', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/Inventory/count/module/inventory-count.module#InventoryCountModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'vandors', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/vandors/module/vandors.module#VandorsModule'},
      {path: '**', redirectTo: '404'}
    ]
  },

  {
    path: 'items', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/items/module/items.module#ItemsModule'},
      {path: 'add', loadChildren: './source/add-items/module/add-items.module#AddItemsModule'},
      {path: 'edit/:id', loadChildren: './source/edit-items/module/edit-item.module#EditItemModule'},
      {path: 'fodiEat_info/:id', loadChildren: './source/items/fodi-eat-info/module/fodi-eat-info.module#FodiEatInfoModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  // POS
  {
    path: 'customers', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/customers/module/customers.module#CustomersModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'sales', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/item_sales/module/item-sales.module#ItemSalesModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'sale-summary', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/sale_summary/module/sale-summary.module#SaleSummaryModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'invoice-refund', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/invoice_refund/module/invoice-refund.module#InvoiceRefundModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'invoice-credit', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/invoice_credit/module/invoice-credit.module#InvoiceCreditModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'item-refund', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/item_refund/module/item-refund.module#ItemRefundModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'transactions', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/transactions-report/module/transactions-report.module#TransactionsReportModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'store-summary', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/store_summary/module/store-summary.module#StoreSummaryModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'inventory-snapshot', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/inventory_snapshot/module/inventory-snapshot.module#InventorySnapshotModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'departments', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/departments/module/departments.module#DepartmentsModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'categories', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/categories/module/categories.module#CategoriesModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'tax', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/tax/module/tax.module#TaxModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'uom', component: BodyComponent,
    children: [
      //Customers Pages
      {path: '', loadChildren: './source/uom/module/uom.module#UomModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'theme', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/theme/module/theme.module#ThemeModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'promotions', component: BodyComponent,
    children: [
      // Promotions Pages
      {path: '', loadChildren: './source/promotions/module/promotions.module#PromotionsModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'loyalty', component: BodyComponent,
    children: [
      // Loyalty Pages
      {path: '', loadChildren: './source/loyality/module/loyality-program.module#LoyalityProgramModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'close', component: BodyComponent,
    children: [
      // Loyalty Pages
      {path: '', loadChildren: './source/closeday/module/close-day.module#CloseDayModule'},
      {path: '**', redirectTo: '404'}
    ]
  }, {
    path: 'day-close-print', component: BodyComponent,
    children: [
      // Loyalty Pages
      {path: '', loadChildren: './source/daycloseprint/day-close-print/day-close-print.module#DayClosePrintModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {path: 'sell', loadChildren: './source/sell/module/sell.module#SellModule'},

  {path: 'kitchen', loadChildren: './source/dining/kitchen/module/kitchen.module#KitchenModule'},

  {path: 'serving', loadChildren: './source/dining/serving/module/serving.module#ServingModule'},

  {
    path: 'tables', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/dining/table/module/table.module#TableModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'dining_section', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/dining/dining-section/module/dining.module#DiningModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'apps/settings', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/dining/settings/apps_settings/module/setting.module#SettingModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'apps/dispatch', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/dining/settings/dispatch_screen/module/dispatch.module#DispatchModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'apps/token', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/dining/token/module/token.module#TokenModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'store', component: BodyComponent,
    children: [
      // Loyalty Pages
      {path: '', loadChildren: './source/stores/stores_module/stores.module#StoresModule'},
      {path: ':id', loadChildren: './source/stores/add-store_module/add-store.module#AddStoreModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'payment', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/payment/module/payment.module#PaymentModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'import-items', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/import_items/module/import-items.module#ImportItemsModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'devices', component: BodyComponent,
    children: [
      // Loyalty Pages
      {path: '', loadChildren: './source/approval/module/devices.module#DevicesModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'attendance-report', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/attendanceReport/module/attendance-report.module#AttendanceReportModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'activity', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/employee_activity/module/employee-activity.module#EmployeeActivityModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'print-report', loadChildren: './source/print-report/module/print-report.module#PrintReportModule',
    // children: [
    //   // Customers Pages
    //   {path: '', loadChildren: './source/print-report/module/print-report.module#PrintReportModule'},
    //   {path: '**', redirectTo: '404'}
    // ]
  },
  {
    path: 'print-invoice/:barcode', loadChildren: './source/print-invoice/module/print-invoice.module#PrintInvoiceModule',
  },
  {
    path: 'customer-import', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/import_customers/module/import-customers.module#ImportCustomersModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'vendor-import', component: BodyComponent,
    children: [
      // Customers Pages
      {path: '', loadChildren: './source/import_vendors/module/import-vendors.module#ImportVendorsModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {
    path: 'denomination', component: BodyComponent,
    children: [
      {path: '', loadChildren: './source/denomination/module/denomination.module#DenominationModule'},
      {path: '**', redirectTo: '404'}
    ]
  },
  {path: '**', redirectTo: '404', pathMatch: 'full'},
  // {path: 'stimulsoftReports', loadChildren:'./source/stimulsoft-report/module/stimulsoft-report.module#StimulsoftReportModule'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {


}

export const routingComponenets = [
  // BodyComponent,
  // LoginComponent,
  // ForgetComponent,
  // ResetComponent,
  // LogoutComponent,
  // DashboardComponent,
];
